<template>
  <div class="discount">
    <span class="discount-count">{{ count }}% OFF</span>
    <!-- <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 0H55.2249L0 55.2249V5C0 2.23858 2.23858 0 5 0Z"
        fill="#FF6B6B"
      />
    </svg> -->
  </div>
</template>

<script>
export default {
  name: "DiscountLabel",
  props: {
    count: String
  },
  data: () => ({})
};
</script>

<style scoped lang="scss" src="./DiscountLabel.scss"></style>
